import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import appService from 'Services/AppService';
import documentationService from 'Services/DocumentationService';
import XssHTMLSanitizer from 'HOC/XssHTMLSanitizer';

const Support = (props) => {
    const {
        match: { params },
    } = props;

    const [app, setApp] = useState({});
    const [docs, setDocs] = useState([]);

    useEffect(() => {
        appService
            .getAppById(params.appId)
            .then((result) => {
                if (result.status === 200) {
                    setApp(result.data);
                }
            })
            .catch();
        documentationService
            .getDocumentationsByAppId(params.appId)
            .then((result) => {
                if (result.status === 200) {
                    setDocs(result.data);
                }
            })
            .catch();
    }, [params]);

    return (
        <Container>
            <div className="pt-2 mt-5 text-center"></div>
            {/* <img src="/images/cli.png" alt="cli" /> */}
            <h4 style={{ fontWeight: 400, fontSize: '24pt' }}>{app.name}</h4>
            <span style={{ fontSize: '9pt' }}>{params.appId}</span>

            <div className="mt-5 text-center"></div>
            {docs.length === 0 ? (
                <Alert variant="secondary">Aucune documentation trouvée.</Alert>
            ) : (
                docs.map((doc) => (
                    <Row className="mt-3" key={doc.documentationId}>
                        <Col md={2}></Col>
                        <Col md={8}>
                            <Card>
                                <Card.Header as="h5">{doc.name}</Card.Header>
                                <Card.Body>
                                    {/* <Card.Text dangerouslySetInnerHTML={{ __html: doc.content }} /> */}
                                    <XssHTMLSanitizer targetComponent={Card.Text} htmlData={doc.content} />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                ))
            )}
        </Container>
    );
};

export default Support;
